<template>
  <div>
    <div>
      <b-row>
        <b-col cols="12">
          <banner-table-header
            :isAdjusted="isAdjusted"
            @onSearch="onSearchBanner"
            @onOpenExportModal="onOpenExportModal"
          />
        </b-col>
        <b-col cols="12" class="mt-1">
          <overlay-loading :loading="loading.tableData">
            <template #content>
              <!-- <b-table
                :items="dynamicTable.payload"
                :fields="dynamicTable.column"
                responsive
                bordered
                borderless
                sticky-header
                no-local-sorting
                show-empty
                class="banner-table"
                @sort-changed="sortingChanged"
              > -->
              <b-table
                :items="dynamicTable.payload"
                :fields="dynamicTable.column"
                responsive
                bordered
                borderless
                sticky-header
                no-local-sorting
                show-empty
                class="default-static-table-vertical"
                @sort-changed="sortingChanged"
              >
                <template
                  v-for="col in dynamicTable.column"
                  v-slot:[renderHead(col.key)]
                >
                  <div
                    :key="col.key + 'head'"
                    :style="{ textAlign: resolveAlign(col.align) }"
                  >
                    {{ $i18n.locale == "th" ? col.label_th : col.label_en }}
                  </div>
                </template>

                <template
                  v-for="col in dynamicTable.column"
                  v-slot:[renderCell(col.key)]="data"
                >
                  <div
                    :key="`column-data-${col.key}`"
                    :style="{ textAlign: resolveAlign(col.align) }"
                  >
                    <component
                      :is="data.field.type_desc"
                      :key="col.key"
                      :column-properties="data"
                    />
                  </div>
                </template>

                <template #head(action)>
                  <span />
                </template>

                <template #cell(action)="data">
                  <action-group
                    v-if="isAdjusted"
                    :resolve-action="resolveBannerAction"
                    :set-action-list="actionList"
                    :item-data="data.item"
                  />
                </template>

                <template #table-busy>
                  <overlay-loading :loading="true" />
                </template>

                <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
                </template>
              </b-table>
            </template>
          </overlay-loading>
        </b-col>
        <b-col cols="12" class="mt-1">
          <pagination-with-reorder
            entity-editable
            :pagination="pagination"
            @entityChange="onFilterEntity"
            @pageChange="onPageChange"
          />
        </b-col>

        <assign-banner-modal
          v-if="formModal.assignBanner"
          :is-set="setMode"
          :banner-id="assignBannerConfig.bannerId"
          @onCloseModal="closeAssignModal"
        />

        <history-report-modal
          v-if="modalPopup.report"
          @onCloseModal="closeReportModal"
          :moduleTypeKey="defaultReportFilterType.module"
          :moduleKey="defaultReport.banner"
        />
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BInputGroupPrepend,
  BInputGroup,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BSpinner,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ImageColumn from "@/views/components/dynamic-table/components/ImageColumn.vue";
import TextColumn from "@/views/components/dynamic-table/components/TextColumn.vue";
import DateColumn from "@/views/components/dynamic-table/components/DateColumn.vue";
import ActionColumn from "@/views/components/dynamic-table/components/ActionColumn.vue";
import OptionColumn from "@/views/components/dynamic-table/components/OptionColumn.vue";
import ActionGroup from "@/views/components/table-action-group/ActionGroup.vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import useBannerList from "../hooks/useBannerList";
import useBannerTable from "../hooks/useBannerTable";
import BannerTableHeader from "./BannerTableHeader.vue";
import AssignBannerModal from "./AssignBannerModal.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";

import HistoryReportModal from "@/views/pages/report/history-report/HistoryReportModal.vue";
import {
  defaultReport,
  defaultReportFilterType,
  defaultReportCategory,
} from "@/configs/dynamic-config/dynamic-report";

export default {
  directives: {
    Ripple,
  },

  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BInputGroupPrepend,
    BInputGroup,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    ImageColumn,
    TextColumn,
    DateColumn,
    ActionColumn,
    OptionColumn,
    AssignBannerModal,
    ActionGroup,
    BSpinner,
    BannerTableHeader,
    CardNoItem,
    PaginationWithReorder,

    HistoryReportModal,
  },

  props: {
    displayKey: String,
    queryDataKey: String,
    queryId: Number,
    isAdjusted: Boolean
  },

  setup(props) {
    const { dynamicTableConfig } = useBannerList();

    const {
      dynamicTable,
      loading,
      actionList,
      assignBannerConfig,
      setMode,
      pagination,
      renderHead,
      renderCell,
      resolveBannerAction,
      resolveAlign,
      closeAssignModal,
      onFilterEntity,
      onPageChange,
      onSearchBanner,
      sortingChanged,
      resolveBannerStatusLabel,

      modalPopup,
      onOpenExportModal,
      closeReportModal,
      formModal
    } = useBannerTable(props);

    return {
      dynamicTableConfig,
      dynamicTable,
      loading,
      actionList,
      assignBannerConfig,
      setMode,
      pagination,
      renderHead,
      renderCell,
      resolveBannerAction,
      resolveAlign,
      closeAssignModal,
      onFilterEntity,
      onPageChange,
      onSearchBanner,
      sortingChanged,
      resolveBannerStatusLabel,

      modalPopup,
      onOpenExportModal,
      closeReportModal,
      defaultReport,
      defaultReportFilterType,
      defaultReportCategory,
      formModal
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/pages/banner/banner-table.css";
</style>
